export * from "./envs/app.configs";
export * from "./envs/train.config"